import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import moment from 'moment'

import Leaves from 'modules/attendance/components/ClockIn/Leaves'
import type Store from 'modules/attendance/components/ClockIn/Store'
import type CalendarDay from 'modules/attendance/store/models/CalendarDay'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  date: moment.Moment
  store: Store
  calendarDay: CalendarDay
}

const DayColumn = ({ date, calendarDay }: Props) => {
  const weekDay = date.format('dddd')
  const monthDay = date.format('D MMM')
  const isToday = date.isSame(moment(), 'day')

  return (
    <Table.Cell verticalAlign="top">
      <Box className={styles.container}>
        <Box
          className={cx('monthDay', {
            isToday,
          })}
        >
          <Text.Normal weight="medium">{monthDay}</Text.Normal>
        </Box>
        <Box
          className={cx('weekDay', {
            isToday,
          })}
        >
          {weekDay}
        </Box>
        <Leaves leaves={calendarDay.leaves} />
      </Box>
    </Table.Cell>
  )
}

export default DayColumn
